module.exports = __webpack_public_path__ + "static/media/lane-not-started.796965d1.png";